__turbopack_context__.v({
  "flyout-bottom-enter": "Flyout-module__ciHHdG__flyout-bottom-enter",
  "flyout-bottom-enter-active": "Flyout-module__ciHHdG__flyout-bottom-enter-active",
  "flyout-bottom-exit": "Flyout-module__ciHHdG__flyout-bottom-exit",
  "flyout-bottom-exit-active": "Flyout-module__ciHHdG__flyout-bottom-exit-active",
  "flyout-left-enter": "Flyout-module__ciHHdG__flyout-left-enter",
  "flyout-left-enter-active": "Flyout-module__ciHHdG__flyout-left-enter-active",
  "flyout-left-exit": "Flyout-module__ciHHdG__flyout-left-exit",
  "flyout-left-exit-active": "Flyout-module__ciHHdG__flyout-left-exit-active",
  "flyout-right-enter": "Flyout-module__ciHHdG__flyout-right-enter",
  "flyout-right-enter-active": "Flyout-module__ciHHdG__flyout-right-enter-active",
  "flyout-right-exit": "Flyout-module__ciHHdG__flyout-right-exit",
  "flyout-right-exit-active": "Flyout-module__ciHHdG__flyout-right-exit-active",
});
